import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from '../meta.service';
import { RegistrationService } from '../registration.service';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {

  //declare variables
  strGate: string = '';
  strTitle: string = '';
  strLink: string = '';
  strButton: string = '';
  strLicense: string = '';
  registrationId: string = '';

  //inject services
  constructor(private mds: MetaService, private router: Router, private route: ActivatedRoute, private rs: RegistrationService) {
    this.route.paramMap.subscribe(p => {
      //lead ID
      this.strGate = p.get('type');

      //see which gatekeeper to apply
      if (this.strGate == 'appliance') {
        this.strTitle = 'A sales representative will be in contact with you soon.  If you are interested in deploying the virtual appliance, you can download below.  NOTE: The virtual appliance is only available for Enterprise Edition (EE) customers.';
        this.strButton = 'Download Appliance';
        this.strLink = 'https://regscale.blob.core.windows.net/iso/regscale.iso';
      } else if (this.strGate == 'purchase') {
        this.strTitle = 'A sales representative will be in contact with you soon.  We look forward to learning more about you compliance and risk automation needs and how we might add value to your organization.';
      } else if (this.strGate == 'download') {
        this.strTitle = 'Click the button below to download your RegScale container.  The container is available for Linux (Ubuntu and Red Hat).  NOTE 1: You will need a Docker Hub login ID and password to pull the container.';
        this.strButton = "Download Container";
        this.strLink = 'https://hub.docker.com/repository/docker/regscale/regscale';
      } else if (this.strGate == 'contact') {
        this.strTitle = 'An authorized RegScale representative will contact you soon to answer your questions and get you started on your compliance journey.  Thanks for connecting with us and we look forward to being a valued partner as your company re-imagines compliance for the 21st Century.';
      } else if (this.strGate == 'sandbox') {
        this.strTitle = "Your sandbox account has been requested.  Within 24 hours, you should receive an invitation via email with your login credentials for the sandbox.  NOTE:  The sandbox is for test and evaluation.  Do not store any sensitive data and be aware that all data can be wiped from the sandbox at any time without notice.";
      } else if (this.strGate == 'partner') {
        this.strTitle = 'An authorized RegScale channel partner representative will contact you soon to discuss next steps in our partnership.  Thanks for connecting with us and we look forward to being your valued partner.';
      } else if (this.strGate == 'register') {
        this.strTitle = 'Your license for RegScale Community Edition (CE) was created successfully.';
        //get the registration ID passed
        this.registrationId = p.get(decodeURI('license'));
        // look up the registered user
        this.rs.findById(this.registrationId).subscribe(x => {
          var register = x;
          //assign the registration
          this.strLicense = register[0]["license"];
        });
      } else {
        console.log("ERROR: Unknown gate: " + this.strGate);
        this.router.navigate(['/notfound']);
      }
    });
  }

  //initialize component
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Thank You';
    var description = 'Thank you for contacting RegScale about RegScale.  We will be in touch soon.';
    var keywords = 'RegScale, RegScale, contact us, thank you';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
